import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Calendar } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center pt-20 overflow-hidden" data-id="element-107">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-108">
        <img src="https://cdn.magicpatterns.com/uploads/7VBe9qEvGUFC3B79qoJMSK/panchosbanner.png" alt="Professional landscaping work" className="w-full h-full object-cover object-center" data-id="element-109" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-forest-900/80 mix-blend-multiply" data-id="element-110" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-4xl mx-auto" data-id="element-112">
          <span className="inline-block py-1 px-3 rounded-full bg-forest-500/20 border border-forest-500/30 text-cream-100 text-sm font-semibold tracking-wider uppercase mb-6 backdrop-blur-sm" data-id="element-113">
            Professional Landscaping
          </span>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight mb-6 drop-shadow-lg" data-id="element-114">
            12+ Years. 2 States. <br className="hidden md:block" data-id="element-115" />
            <span className="text-cream-200 italic" data-id="element-116">
              One Standard: Done Right — Every Time.
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-cream-100 mb-10 font-light drop-shadow-md" data-id="element-117">
            Serving Northern Illinois & Southern Wisconsin
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-118">
            <a href="tel:8153540484" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-forest-500 hover:bg-forest-700 text-white px-8 py-4 rounded-full font-bold text-lg transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1" data-id="element-119">
              <Phone size={22} data-id="element-120" />
              <span data-id="element-121">Call Now</span>
            </a>
            <a href="#contact" onClick={e => {
            e.preventDefault();
            document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="w-full sm:w-auto flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white border-2 border-white/30 backdrop-blur-sm px-8 py-4 rounded-full font-bold text-lg transition-all" data-id="element-122">
              <Calendar size={22} data-id="element-123" />
              <span data-id="element-124">Free Estimate</span>
            </a>
          </div>
        </motion.div>
      </div>

      {/* Decorative bottom wave/curve could go here, but keeping it clean with a gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-cream-100 to-transparent z-10" data-id="element-125" />
    </section>;
}